import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { DashboardOverviewPage } from './pages/DashboardOverviewPage';
import { DashboardInvestorsPage } from './pages/DashboardInvestorsPage';
import { DashboardPositioningPage } from './pages/DashboardPositioningPage';
import InsightsPage from './pages/InsightsPage';
import { WorkshopSubmissionPage } from './pages/WorkshopSubmissionPage';
import ClerkProvider from './shared/providers/ClerkProvider';
import { ThemeProvider } from './shared/providers/ThemeProvider';
import ProtectedRoute from './features/auth/components/ProtectedRoute';
import AuthToastHandler from './features/auth/components/AuthToastHandler';
import { DashboardNav } from './shared/components/dashboard/DashboardNav';
import useApiClient from './shared/hooks/useApiClient';
import HomePage from './pages/HomePage';
import { DashboardProvider } from './shared/providers/DashboardProvider';

function AppContent() {
  // Initialize API client with Clerk authentication
  useApiClient();

  return (
    <BrowserRouter>
      <Routes>
        {/* Public workshop submission - no auth required */}
        <Route path="/" element={<WorkshopSubmissionPage />} />
        <Route path="/upload" element={<WorkshopSubmissionPage />} />
        <Route path="/workshop/submit" element={<WorkshopSubmissionPage />} />
        <Route path="/insights/*" element={<InsightsPage />} />
        <Route path="/ta25/insights" element={<Navigate to="/insights/positioning" replace />} />

        {/* Protected dashboard routes */}
        <Route
          path="/dashboard/*"
          element={
            <ProtectedRoute>
              <>
              <DashboardProvider>
                <DashboardNav />
                <Routes>
                  <Route index element={<Navigate to="/dashboard/positioning" replace />} />
                  <Route path="positioning" element={<DashboardPositioningPage />} />
                  <Route path="investors" element={<DashboardInvestorsPage />} />
                  <Route path="overview" element={<DashboardOverviewPage />} />
                  <Route path="home" element={<HomePage />} />
                </Routes>
              </DashboardProvider>
              </>
            </ProtectedRoute>
          }
        />
        {/* Backwards compatibility for /view paths */}
        <Route path="/view/*" element={<Navigate to="/dashboard/positioning" replace />} />
      </Routes>
      <Toaster 
        position="top-right"
        richColors
        closeButton
        toastOptions={{
          duration: 4000,
          style: {
            borderRadius: '12px',
            padding: '16px',
            fontSize: '14px',
          },
        }}
      />
    </BrowserRouter>
  );
}

function App() {
  return (
    <ClerkProvider>
      <ThemeProvider>
        <AuthToastHandler>
          <AppContent />
        </AuthToastHandler>
      </ThemeProvider>
    </ClerkProvider>
  );
}

export default App;
